import { SessionHistoryTimeline } from 'common/components/SessionHistory/services/SessionHistoryApi';
import { GetElementType } from 'common/tsHelpers';
import { createContext } from 'react';

export type SessionSelection = {
  index: number | null;
  positionX: number | null;
  setName: 'Primary' | 'Backup' | null;
};

export type SessionToDisplaySelection = {
  index: number | null;
  setName: 'Primary' | 'Backup' | null;
};

export const DEFAULT_SESSION_SELECTION: SessionSelection = {
  index: null,
  positionX: 0,
  setName: 'Primary',
};

export const SessionHistoryContext = createContext<{
  error: boolean;
  loading: boolean;
  primaryIccid: string;
  secondaryIccid: string;
  primaryImsi: string;
  secondaryImsi: string;
  primarySessionHistory: SessionHistoryTimeline;
  backupSessionHistory: SessionHistoryTimeline;
  selectedSession: GetElementType<SessionHistoryTimeline> | null;
  sessionSelection: SessionSelection;
  selectSession?: (sessionSelection: SessionSelection) => void;
  sessionToDisplaySelection: SessionToDisplaySelection;
  sessionToDisplay: GetElementType<SessionHistoryTimeline> | null;
  displaySession?: (sessionSelection: SessionToDisplaySelection) => void;
  refetch: () => void;
}>({
  error: false,
  loading: true,
  primarySessionHistory: [],
  backupSessionHistory: [],
  selectedSession: null,
  sessionSelection: DEFAULT_SESSION_SELECTION,
  refetch: () => {},
  sessionToDisplaySelection: { ...DEFAULT_SESSION_SELECTION },
  sessionToDisplay: null,
  primaryIccid: '',
  secondaryIccid: '',
  primaryImsi: '',
  secondaryImsi: '',
});
